import initModals from './modals.js';
import initSliders from './sliders.js';
initModals();
initSliders();
